<template>
  <el-card>
    <template #header>
      <content-header />
    </template>

    <el-button-group class="mb-3">
      <search-form :fields="search" />
      <el-button v-if="hasPermsAdd" @click="createDialog = true">添加</el-button>
      <el-button>
        基金池总金额：
        <span style="color: #e6a23c;">{{ total_amount }}</span>
        元
      </el-button>
    </el-button-group>

    <el-table :data="stagentFunds" resource="stagent-funds">
      <el-table-column prop="id" label="编号" width="80" />
      <el-table-column align="center" header-align="center" label="贡献人" width="200">
        <template slot-scope="scope">
          <div v-if="scope.row.user">
            <span>{{ scope.row.user.real_name }}({{ scope.row.user.level_info.level_name }})</span>
            <br />
            <span>{{ scope.row.user.mobile }}</span>
            <br />
            <span>{{ scope.row.user.idcard_no }}</span>
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="order_id" label="订单号" width="190" />
      <el-table-column label="类型" width="100">
        <template slot-scope="scope">
          <el-tag type="success" disable-transitions>{{ scope.row.fund_type_text }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="final_amount" label="金额" width="100" />
      <el-table-column label="产品信息" width="180">
        <template slot-scope="scope">
          <span v-if="scope.row.pro_id > 0">{{ scope.row.pro_name }}(x{{ scope.row.pro_num }})</span>
        </template>
      </el-table-column>
      <el-table-column prop="created_at" label="添加时间" width="170" />
      <el-table-column prop="remark" label="描述" />
    </el-table>
    <div class="card-footer"><pagination :page="page" /></div>

    <el-dialog title="新增流水" :visible.sync="createDialog" width="400px" append-to-body>
      <lz-form style="width: auto;" ref="form" :submit="onStoreStagentFund" :errors.sync="errors" :form.sync="form" label-position="top" in-dialog disable-redirect disable-stay>
        <el-form-item label="金额" required prop="amount">
          <el-input v-model="form.amount" autofocus />
          <el-alert title="负数表示扣除" type="info" show-icon :closable="false" />
        </el-form-item>
        <el-form-item label="描述" required prop="remark"><el-input v-model="form.remark" /></el-form-item>
      </lz-form>
    </el-dialog>
  </el-card>
</template>

<script>
import SearchForm from '@c/SearchForm';
import Pagination from '@c/Pagination';
import LzForm from '@c/LzForm';
import { getStagentFunds, storeStagentFund } from '@/api/stagent-funds';
import { can } from '@/libs/utils'

export default {
  name: 'Index',
  components: {
    SearchForm,
    Pagination,
    LzForm
  },
  data() {
    return {
      search: [
        {
          field: 'fund_type',
          label: '基金类型',
          type: 'el-select',
          options: [{id: 0, name: '购买投入'}, {id: 1, name: '手工调整'}],
          labelField: 'name', // 默认为 name
          valueField: 'id' // 默认为 id
        },
        {
          field: 'order_id',
          label: '订单号'
        },
        {
          field: 'keyword',
          label: '手机/姓名'
        },
        {
          field: 'created_at',
          label: '获得时间',
          type: 'el-date-picker'
        }
      ],
      stagentFunds: [],
      total_amount: 0,
      page: null,
      query: {},

      createDialog: false,
      form: {
        amount: '',
        remark: ''
      },
      errors: {},
      hasPermsAdd: false
    };
  },
  created() {
    this.hasPermsAdd = can('stagent-funds.add');
  },
  methods: {
    async onStoreStagentFund() {
      const {data} = await storeStagentFund(this.form);

      this.createDialog = false;
      this.loadData();
    },
    async loadData() {
      const {
        data: {data, meta, total_amount}
      } = await getStagentFunds(this.query);
      this.stagentFunds = data;
      this.page = meta;
      this.total_amount = total_amount;
    }
  },
  watch: {
    $route: {
      async handler(newVal) {
        this.query = newVal.query;
        this.loadData();
      },
      immediate: true
    },
    createDialog(newVal) {
      if (!newVal) {
        this.form = {
          amount: '',
          remark: ''
        };
      }
    }
  }
};
</script>
